import { DollarSign } from "lucide-react";
import { cn } from "@/lib/utils";
import { PRICING_PREFERENCE_OPTIONS, type LeadFormData } from "../types";

interface Props {
  data: LeadFormData;
  onChange: (patch: Partial<LeadFormData>) => void;
}

export function StepPricingPreference({ data, onChange }: Props) {
  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-brand-blue">
          <DollarSign className="h-4 w-4" />
          Pricing Preference
        </div>
        <h2 className="text-balance text-3xl font-bold tracking-tighter text-foreground sm:text-4xl">
          Which pricing model feels right for your business?
        </h2>
        <p className="text-base text-muted-foreground">
          Every plan includes a free mockup before you commit.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {PRICING_PREFERENCE_OPTIONS.map((opt) => {
          const selected = data.pricingPreference === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onChange({ pricingPreference: opt.value })}
              className={cn(
                "w-full rounded-xl border bg-background px-5 py-4 text-left transition-all",
                "hover:border-brand-blue hover:shadow-sm",
                selected
                  ? "border-brand-blue bg-brand-blue/5 ring-2 ring-brand-blue/30"
                  : "border-border",
              )}
            >
              <div className="text-sm font-semibold text-foreground">{opt.title}</div>
              <div className="mt-1 text-xs text-muted-foreground">{opt.subtitle}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
